'use client';

import Link from 'next/link';
import { formatCount } from '@/lib/utils';
import type { ViewMode } from './use-discover';

interface TagPillProps {
  tag: {
    id: string;
    name: string;
    useCount?: number;
    color?: string | null;
  };
  viewMode: ViewMode;
}

export function TagPill({ tag, viewMode }: TagPillProps) {
  if (viewMode === 'list') {
    return (
      <Link
        href={`/discover?type=posts&tags=${tag.name}`}
        className="flex items-center justify-between p-3 rounded-xl hover:bg-accent/50 transition-colors"
      >
        <span className="text-sm font-medium">#{tag.name}</span>
        <span className="text-xs text-muted-foreground">{formatCount(tag.useCount || 0)} uses</span>
      </Link>
    );
  }

  return (
    <Link
      href={`/discover?type=posts&tags=${tag.name}`}
      className="card flex flex-col items-start p-4 rounded-xl hover:shadow-md transition-all"
    >
      <span className="text-sm font-semibold">#{tag.name}</span>
      <span className="text-xs text-muted-foreground mt-1">{formatCount(tag.useCount || 0)} uses</span>
    </Link>
  );
}
